import { Service, signal } from '@angular/core';

@Service()
export class InitialLoadingService {
  readonly showLoading = signal(true);
}
